import * as React from 'react';
import { useContext } from 'react';
import { IContext } from '../../teams-sdk/teamsSdk';
import { getTeamsContextAsPromise } from '../get-teams-context';
import {
  ITeamsContextProps,
  ITeamsContextProviderProps,
  ITeamsContextProviderState
} from './TeamsContext.types';

export const TeamsContext = React.createContext<ITeamsContextProps>({
  teamsContext: undefined
});

export class TeamsContextProvider extends React.Component<
  ITeamsContextProviderProps,
  ITeamsContextProviderState
> {
  constructor(props: ITeamsContextProviderProps) {
    super(props);
    this.state = {
      teamsContext: undefined
    };
  }

  public render(): JSX.Element {
    return (
      <TeamsContext.Provider value={this.state}>
        {this.props.children}
      </TeamsContext.Provider>
    );
  }

  public componentDidMount(): void {
    getTeamsContextAsPromise()
      .then((teamsContext: IContext) => {
        this.setState({
          teamsContext: teamsContext
        });
      })
      .catch(error =>
        console.error(`TeamsContext: failed to get context because of ${error}`)
      );
  }
}

export const useTeamsContext = () =>
  useContext<ITeamsContextProps>(TeamsContext);
